// Subject options a student can filter by, specific to their grade.
export const gradeSubjectOptions = (grade) => {
  if (grade === "8") return ["Science", "Maths - Ganita Prakash I", "Maths - Ganita Prakash II"];
  if (grade === "9") return ["Science", "Maths - Ganita Manjari I", "Maths - Ganita Manjari II"];
  return ["Science", "Maths"];
};

// Short display label (drops the "Maths - " prefix from Ganita subjects).
export const subjectLabel = (s) => (s || "").replace(/^Maths - /, "");
